import React from "react";
import { Header, Paper, SkeletonLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import { Page } from "~/components/Page";
import MainLogo from "~/components/svg/MainLogo";
import "./OnboardingLayout.less";

export const OnboardingLayout = ({ children }) => {
  return (
    <div className="tw-hidden tw-h-screen sm:tw-flex tw-gap-1">
      <div className="tw-flex tw-flex-col tw-gap-4 tw-w-60 tw-shrink-0">
        <div className="tw-flex tw-w-full tw-py-6 tw-pl-8 tw-items-center main-logo-url ">
          <MainLogo />
        </div>
        <div className="tw-flex tw-flex-col tw-h-full tw-items-center tw-px-6">
          <SkeletonLoader className="tw-w-full" />
          <div className="tw-flex tw-flex-col tw-w-full tw-mt-4 tw-pl-3 ">
            {[...Array(10)].map((_, index) => (
              <span
                key={index}
                className="tw-flex tw-h-10 tw-w-full tw-gap-4 tw-items-center"
              >
                <SkeletonLoader className="tw-w-4" />
                <SkeletonLoader className="tw-w-full" />
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="tw-flex tw-flex-col tw-grow tw-flex-1 tw-w-full tw-h-full tw-pr-8">
        <Page className="tw-flex tw-flex-col">
          <div className="tw-flex tw-py-6 tw-items-center tw-gap-4 tw-justify-between">
            <SkeletonLoader className="tw-w-full" />
            <div className="tw-flex tw-w-40 tw-pl-4 tw-justify-between">
              {[...Array(4)].map((_, index) => (
                <SkeletonLoader
                  key={index}
                  className="tw-w-4"
                />
              ))}
            </div>
          </div>
          <Page.Body className="tw-flex tw-flex-col tw-gap-4">
            <Header className="tw-flex tw-bg-page-paper-main tw-items-center tw-w-full tw-h-16">
              <SkeletonLoader className="tw-w-full" />
            </Header>
            <Paper
              type="paper-2"
              className="tw-flex tw-h-full"
            >
              {children}
            </Paper>
          </Page.Body>
        </Page>
      </div>
    </div>
  );
};

OnboardingLayout.propTypes = {
  children: PropTypes.any,
};

export default OnboardingLayout;
